import { ComponentClass, FunctionComponent } from 'react';

export function isClassComponent(component: unknown): component is ComponentClass {
    return typeof component === 'function' && !!component.prototype?.isReactComponent;
}

export function isFunctionComponent(component: unknown): component is FunctionComponent {
    return typeof component === 'function' && !component.prototype?.isReactComponent;
}
